export default __webpack_public_path__ + "static/media/looker.162d4229.svg";